export enum CharCodes {
  CERO = 48,
  NUEVE = 57,
  DELETE = 46,
}
